document.addEventListener('DOMContentLoaded', function () {
	const jobOpeningElements = document.querySelectorAll('.icon-video');
	jobOpeningElements.forEach(jobOpeningElement => {
		const playButton = jobOpeningElement.querySelector('#play-video');
		const careerIndexModal = jobOpeningElement.querySelector('.career-modal');
		playButton.addEventListener('click', () => {
			const videoHtml = playButton.querySelector('video');
			videoHtml.pause();
			const modalDetails = jobOpeningElement.querySelector('.modal-details');
			document.body.classList.add('scroll-fix');

			modalDetails.insertAdjacentHTML(
				'beforeend',
				`<video width="100%" height="auto" preload="metadata" controls autoplay>${videoHtml.innerHTML}</video>`,
			);
			const careerPopup = careerIndexModal;
			careerPopup.style.display = 'block';
		});

		const closeIcon = jobOpeningElement.querySelector('#close-icon-index');
		closeIcon.addEventListener('click', () => {
			const videoTag = jobOpeningElement.querySelector('.modal-details video');
			videoTag.remove();
			const careerPopup = careerIndexModal;
			careerPopup.style.display = 'none';
			document.body.classList.remove('scroll-fix');
		});

		const anchorButton = jobOpeningElement.querySelector('#anchor-play-video');
		anchorButton.addEventListener('click', () => {
			playButton.click();
		});

		const modalDetails = jobOpeningElement.querySelector('.modal-details');
		modalDetails.addEventListener('click', e => {
			if (!modalDetails.querySelector('video').contains(e.target)) {
				const videoTag = modalDetails.querySelector('video');
				videoTag.remove();
				const careerPopup = careerIndexModal;
				careerPopup.style.display = 'none';
				document.body.classList.add('scroll-fix');
			}
		});
	});
	document.addEventListener('keydown', event => {
		if (event.key === 'Escape') {
			const videoTag = document.querySelector('.modal-details video');
			if (videoTag !== undefined && videoTag !== null) {
				const modParHtml = videoTag.parentElement.parentElement.parentElement;
				videoTag.remove();
				modParHtml.removeAttribute('style');
				document.body.classList.remove('scroll-fix');
			}
		}
	});
});
